export const modelViewerLocalStorageKey = 'model-viewer-config';
